import {
  Document,
  Font,
  Image,
  Page,
  StyleSheet,
  Text,
  View,
} from "@react-pdf/renderer";
import React from "react";

const fontFiles = [
  {
    src: "/Inter/static/Inter_18pt-Regular.ttf",
    fontWeight: 400,
    fontStyle: "normal",
  },
  {
    src: "/Inter/static/Inter_24pt-Regular.ttf",
    fontWeight: 400,
    fontStyle: "normal",
  },
  {
    src: "/Inter/static/Inter_28pt-Regular.ttf",
    fontWeight: 400,
    fontStyle: "normal",
  },
  {
    src: "/Inter/static/Inter_18pt-Medium.ttf",
    fontWeight: 500,
    fontStyle: "normal",
  },
  {
    src: "/Inter/static/Inter_24pt-Medium.ttf",
    fontWeight: 500,
    fontStyle: "normal",
  },
  {
    src: "/Inter/static/Inter_28pt-Medium.ttf",
    fontWeight: 500,
    fontStyle: "normal",
  },
  {
    src: "/Inter/static/Inter_18pt-SemiBold.ttf",
    fontWeight: 600,
    fontStyle: "normal",
  },
  {
    src: "/Inter/static/Inter_24pt-SemiBold.ttf",
    fontWeight: 600,
    fontStyle: "normal",
  },
  {
    src: "/Inter/static/Inter_28pt-SemiBold.ttf",
    fontWeight: 600,
    fontStyle: "normal",
  },
  {
    src: "/Inter/static/Inter_18pt-Bold.ttf",
    fontWeight: 700,
    fontStyle: "normal",
  },
  {
    src: "/Inter/static/Inter_24pt-Bold.ttf",
    fontWeight: 700,
    fontStyle: "normal",
  },
  {
    src: "/Inter/static/Inter_28pt-Bold.ttf",
    fontWeight: 700,
    fontStyle: "normal",
  },
  {
    src: "/Inter/static/Inter_18pt-ExtraBold.ttf",
    fontWeight: 800,
    fontStyle: "normal",
  },
  {
    src: "/Inter/static/Inter_24pt-ExtraBold.ttf",
    fontWeight: 800,
    fontStyle: "normal",
  },
  {
    src: "/Inter/static/Inter_28pt-ExtraBold.ttf",
    fontWeight: 800,
    fontStyle: "normal",
  },
];

fontFiles.forEach((font) => {
  Font.register({
    family: "Inter",
    fonts: [
      {
        src: font.src,
        fontWeight: font.fontWeight,
        fontStyle: font.fontStyle,
      },
    ],
  });
});

const styles = StyleSheet.create({
  page: { padding: 15, fontSize: 12, fontFamily: "Inter", paddingBottom: 35 },
  section_split: {
    flexDirection: "row",
    gap: 10,
    justifyContent: "space-between",
    width: "100%",
    marginBottom: 10,
    alignItems: "center",
  },
  section: {
    flexDirection: "column",
    backgroundColor: "#F5F6F7",
    padding: 10,
    gap: 5,
    width: "50%",
  },

  label: {
    fontWeight: 800,
    // marginBottom: 4,
    color: "#475E75",
    fontSize: 9,
  },
  labelName: { fontWeight: 500, fontSize: 9 },
  section1Heading: {
    fontSize: 15,
    color: "#101828",
    fontWeight: 600,
    marginTop: 20,
  },
  section1_split: {
    flexDirection: "row",
    gap: 10,
    flexWrap: "wrap",
    width: "100%",
    marginTop: 15,
  },
  section1_inner_split: {
    border: "1px solid #EAECF0",
    padding: 7,
  },
  section1_inner_title: {
    fontSize: 10,
    fontWeight: 500,
    fontFamily: "Inter",
    color: "#475467",
  },
  section1_inner_value: {
    fontSize: 11,
    fontWeight: 700,
    marginTop: 5,
    fontFamily: "Inter",
    color: "#101828",
  },
  footer: {
    position: "absolute",
    right: 12,
    bottom: 12,
    fontSize: 10,
    fontWeight: 600,
  },
});

export default function PreScreenPDF({ values, lg }) {
  const storageData = JSON.parse(localStorage.getItem("credential"));
  const org_label = storageData?.org_label;
  const org_logo_url = storageData?.org_logo_url;

  return (
    <Document>
      <Page size="A4" style={styles.page}>
        <View style={styles.section_split} fixed>
          {org_label ? (
            <Text
              style={{
                fontSize: 12,
              }}
            >
              {org_label}
            </Text>
          ) : (
            // GetWhiteLabelAvatar(org_label, org_logo_url, lg)
            <Image
              src="data:image/png;base64,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"
              style={{ width: 100, height: 30 }}
            />
          )}

          <View style={styles.section}>
            <Text style={styles.label}>
              Job / Req ID :
              <Text style={styles.labelName}> {values.job_id}</Text>
            </Text>

            <Text style={styles.label}>
              Candidate :
              <Text style={styles.labelName}> {values.first_name}</Text>
            </Text>
          </View>
        </View>
        <Text style={[styles.section1Heading, { marginTop: 10 }]}>
          Pre-Screening Questions and Answers
        </Text>
        <View style={styles.section1_split}>
          {values.pre_screen_question_answers.map((item, index) => (
            <View
              key={index}
              style={{
                ...styles.section1_inner_split,
                width: "100%",
                padding: 8,
              }}
            >
              <Text style={{ ...styles.section1_inner_title, fontSize: 11 }}>
                Q{index + 1}: {item.question}
              </Text>
              <Text
                style={{
                  ...styles.section1_inner_value,
                  fontSize: 12,
                  marginTop: 7,
                }}
              >
                {item.answer}
              </Text>
            </View>
          ))}
        </View>

        <Text
          style={styles.footer}
          render={({ pageNumber, totalPages }) =>
            `Page ${pageNumber} of ${totalPages}`
          }
          fixed
        />
      </Page>
    </Document>
  );
}
